import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import { fetchMe, type Wallet } from '../lib/me';
import './TopNav.css';

const LINKS = [
  { labelKey: 'nav.stories', to: '/stories' },
  { labelKey: 'nav.heroes', to: '/heroes' },
  { labelKey: 'nav.profile', to: '/profile' },
];

export function TopNav() {
  const { t } = useTranslation();
  const [wallet, setWallet] = useState<Wallet | null>(null);
  const { pathname } = useLocation();

  // Refetch on navigation so the pill stays current after story/hero creation.
  useEffect(() => {
    let cancelled = false;
    fetchMe()
      .then((me) => {
        if (!cancelled) setWallet(me.wallet);
      })
      .catch(() => {
        // Wallet pill is optional; silently omit on failure.
      });
    return () => {
      cancelled = true;
    };
  }, [pathname]);

  return (
    <nav className="top-nav">
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          className={({ isActive }) =>
            isActive ? 'top-nav__link top-nav__link--active' : 'top-nav__link'
          }
        >
          {t(link.labelKey)}
        </NavLink>
      ))}
      {wallet && (
        <span
          className="token-pill"
          title={t('nav.walletTitle', {
            plan_tokens: wallet.plan_tokens,
            package_tokens: wallet.package_tokens,
          })}
        >
          {t('nav.walletPill', {
            total: wallet.total,
            plan: wallet.plan_name,
          })}
        </span>
      )}
    </nav>
  );
}
